import React from 'react';
import ContentsListItem from '@components/common/contentsListItem';
import { ContentsListItemVO } from '@domain/vo/common/ContentsListItemVO';
import { InfoCardVO } from '@domain/vo/info/infoCardVO';
import { ContentRouteUtil } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './infoDetailRecommendList.module.scss';

const cx = classnames.bind(styles);

interface Props {
  cardList?: InfoCardVO[];
  handleClick: (privacy: ContentsListItemVO) => boolean;
}

const InfoDetailRecommendList = ({ cardList, handleClick }: Props) => {
  const renderInfoCardEls = cardList?.map((infoCard) => (
    <ContentsListItem
      key={infoCard.sn}
      contentData={{
        ...infoCard,
        name: infoCard.categoryName,
        tag: infoCard.label,
        routeUrl: ContentRouteUtil.getInfoDetailPage(infoCard.sn),
      }}
      handleClick={handleClick}
    />
  ));

  return <ul className={cx('recommendList')}>{renderInfoCardEls}</ul>;
};

export default InfoDetailRecommendList;
